export const events = {
  eventsCardDurationText: 'Czas trwania',
  eventsSearchInputText: 'Szukaj',
  eventsRegisteredToEventAlertTitle: 'Zarejestrowano pomyślnie',
  eventsUnregisteredToEventAlertTitle: 'Wyrejestrowano pomyślnie',
  eventsExternalRegistrationPopupTitle: 'Zarejestruj się',
  eventsExternalRegistrationPopupContent: 'Czy zarejestrowano pomyślnie?',
  eventsExternalRegistrationNoButtonTitle: 'Nie',
  eventsExternalRegistrationYesButtonTitle: 'Tak',
  eventsCurtainCopyOptionTitle: 'Skopiuj link',
  eventsCurtainFlagOptionTitle: 'Zgłoś treść',
  eventsLinkCopiedAlertText: 'Link skopiowany!',
  eventsCurtainAddToCalendOptionTitle: 'Dodaj do kalendarza',
  eventdetailsAgendaButtonTitle: 'Agenda',
  eventdetailsOnMapButtonTitle: 'Na mapie',
  eventdetailsOnlineLocationTitle: 'Online',
  eventdetailAmountsRegisteredText: 'Uczestnicy',
  eventdetailsSeeAllButtonTitle: 'Zobacz wszystkie',
  eventdetailsRegisteredButtonTitle: 'Zarejestruj',
  eventdetailsRegisterButtonTitle: 'Zarejestruj',
  eventdetailsRegisteredAlertText: 'Zarejestrowano pomyślnie',
  eventdetailsUnregisteredAlertText: 'Wyrejestrowano pomyślnie',
  eventdetailsAgendaTitle: 'Agenda',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Zarejestrowani użytkownicy',
  eventdetailsSpeakersCurtainTitle: 'Prelegenci',
  eventdetailsSpeakersSectionTitle: 'Prelegenci',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Zobacz wszystkich',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Zobacz wszystkie',
  eventdetailsCurtainCopyOptionTitle: 'Skopiuj link',
  eventdetailsCurtainFlagOptionTitle: 'Zgłoś treść',
  eventsdetailsLinkCopiedAlertText: 'Link skopiowany!',
  eventdetailsCurtainAddToCalOptionTitle: 'Dodaj do kalendarza',
  eventDetailsAddCalendarPopupTitle: 'Kalendarz',
  eventdetailsAddCalendarPopupContent: 'Dodać do kalendarza?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'Nie',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Tak',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Skopiuj link',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Zgłoś treść',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Link skopiowany!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Skopiuj link',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Zgłoś treść',
  eventsFlag: 'Zgłoś',
  eventsJoin: 'Dołącz',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Link skopiowany!',
  eventContentReported: 'Treść zgłoszona',
  eventsError: 'Coś poszło nie tak!',
  eventdetailsExternalRegistrationPopupContent: 'Czy zarejestrowano pomyślnie?',
  eventdetailsExternalRegistrationNoButtonTitle: 'Nie',
  eventdetailsExternalRegistrationYesButtonTitle: 'Tak',
  eventdetailsExternalRegistrationPopupTitle: 'Zarejestruj się',
  eventsCardRegisteredButtonTitle: 'Zarejestrowani',
  eventsCardRegisterButtonTitle: 'Zarejestruj',
  eventsJoinLink: 'Link do dołączenia: [url]{link}[/url][br]',
  eventsGuest: 'Gość',
  eventsNoSessionInDay: 'Brak wydarzeń tego dnia.',
  eventsShowUpcomingEvent: 'Pokaż nadchodzące wydarzenie'
}
